import { render, staticRenderFns } from "./ed-whiteboard-users.vue?vue&type=template&id=44b4ceb8&scoped=true&"
import script from "./ed-whiteboard-users.ts?vue&type=script&lang=ts&"
export * from "./ed-whiteboard-users.ts?vue&type=script&lang=ts&"
import style0 from "./ed-whiteboard-users.scss?vue&type=style&index=0&id=44b4ceb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b4ceb8",
  null
  
)

export default component.exports